import { deserialize } from "serializr";
import axiosInstance from "../../interceptor/axiosInstance";
import { MetaModel } from "../../models/CourseModels/SubjectModel/subject.model";
import { BranchMetaModel } from "../../models/InstituteModel/branches.model";
import { InstituteTutorsMetaModel } from "../../models/InstituteModel/liveClass.model";
import * as ApiRoutes from "../../routes/routeConstants/apiRoutes";
import { StudentMetaModel } from "../../models/InstituteModel/students.model";

export class MetaService {
  static fetchInstituteBranchesMeta(
    instituteId: number,
    onSuccess: (value: MetaModel[]) => void,
    onError: Function,
    onFinal: () => void
  ) {
    axiosInstance
      .get(ApiRoutes.INSTITUTE_BRANCHES_META, {
        params: {
          institute_id: instituteId,
        },
      })
      .then((response) => {
        const data = deserialize(MetaModel, response.data["branches"]);
        onSuccess(data as MetaModel[]);
      })
      .catch((error) => {
        onError();
      })
      .finally(() => {
        onFinal();
      });
  }
  static fetchInstituteSectionsMeta(
    branchClassRoomId: number,
    onSuccess: (value: MetaModel[]) => void,
    onError: Function,
    onFinal: () => void
  ) {
    axiosInstance
      .get(ApiRoutes.INSTITUTE_SECTIONS_META, {
        params: {
          branch_class_room_id: branchClassRoomId,
        },
      })
      .then((response) => {
        const data = deserialize(MetaModel, response.data["sections"]);
        onSuccess(data as MetaModel[]);
      })
      .catch((error) => {
        onError();
      })
      .finally(() => {
        onFinal();
      });
  }
  static fetchInstituteSectionSubjectsMeta(
    sectionsIds: number[],
    onSuccess: (value: MetaModel[]) => void,
    onError: Function,
    onFinal: () => void
  ) {
    axiosInstance
      .get(ApiRoutes.INSTITUTE_SECTION_SUBJECTS_META, {
        params: {
          section_ids: sectionsIds,
        },
      })
      .then((response) => {
        const data = deserialize(MetaModel, response.data["subjects"]);
        onSuccess(data as MetaModel[]);
      })
      .catch((error) => {
        onError();
      })
      .finally(() => {
        onFinal();
      });
  }
  static fetchInstituteTutorsMeta(
    branchId: number,
    onSuccess: (value: InstituteTutorsMetaModel[]) => void,
    onError: Function,
    onFinal: () => void
  ) {
    axiosInstance
      .get(ApiRoutes.INSTITUTE_TUTORS_META, {
        params: {
          branch_id: branchId,
        },
      })
      .then((response) => {
        const data = deserialize(InstituteTutorsMetaModel, response.data["tutors"]);
        onSuccess(data as InstituteTutorsMetaModel[]);
      })
      .catch((error) => {
        onError();
      })
      .finally(() => {
        onFinal();
      });
  }

static fetchSectionStudentsMeta(
    section_ids: number[],
    onSuccess: (value: StudentMetaModel[]) => void,
    onError: Function,
    onFinal: () => void
  ) {
    return axiosInstance
      .get(ApiRoutes.SECTION_STUDENTS_META, { params: { section_id: section_ids } })
      .then((response) => {
        const data = deserialize(StudentMetaModel, response.data["students"]) as StudentMetaModel[];
        onSuccess(data);
      })
      .catch((error) => {
        onError();
      })
      .finally(() => {
        onFinal();
      });
  }
}
